export default __webpack_public_path__ + "static/media/product21_sportshoe.d473dddc.webp";